export const FALLBACK_MISSION_IMAGE_URL =
  'data:image/svg+xml;utf-8,<svg xmlns="http://www.w3.org/2000/svg" width="300" height="50"><rect x="0" y="0" height="50" width="300" style="color: black;" /></svg>';
